// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-item/carousel-item.component.scss
// module id = 119
// module chunks = 0